import React from 'react';
export default function RadioInvitationStatus({ state }) {
  if (!state.invitation) return null;
  return <section className="jg-radio-invitation-status" role="status" aria-label="Radio invitation">
    <p>{state.unavailable ? 'This invited record is no longer available.' : state.switchRequired ?
      'A different record is playing. Your music will keep playing until you choose.' : 'Finding your invited record…'}</p>
    {state.switchRequired && <button type="button" onClick={state.switchRecord}>Switch to this record</button>}
    <button type="button" onClick={state.dismiss}>{state.unavailable ? 'Explore Radio' : 'Keep listening'}</button>
  </section>;
}
